import React from "react";
import { useNavigate } from "react-router-dom";
import LandingLayout from "../../Layouts/LandingLayout";
import { 
  Paper, 
  Button,  
  Typography,
  Box
} from "@mui/material";
import TranslationContent from "../../Translations/TranslationContent";
import { loginRequest } from "../../authConfig";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import LoadingSpinner from "../Loading/LoadingSpinner";


const Login = () => {
  const [error, setError] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();

  React.useEffect(() => {
    if(isAuthenticated) {
      setLoading(true);
      navigate("/roles")
    }
    else {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[isAuthenticated])

  const handleLogin = () => {
    setLoading(true)
    console.log(isAuthenticated);
    instance.loginRedirect(loginRequest)
      .then(response => {
        console.log(response);
      })
      .catch(error => {
        setError(error);
      })
  }
  if(loading) { 
    return (
      <Box sx={{ margin: "auto", display: "flex", width: "100vw", height: "100vh", justifyContent: "center", alignItems: "center" }}>
        <LoadingSpinner />
      </Box>
    )
  }
  else {
    return (
      <LandingLayout>
        <Paper sx={{maxWidth: "500px", margin: "auto", textAlign: "center", marginTop: "25px"}}>
          <br />
          <Typography variant="h5"><TranslationContent contentID="loginHeader" /></Typography>
          <Typography variant="caption"><TranslationContent contentID="loginCaption" /></Typography>
          <br />
          <br />
          {error && 
            <>
              <Typography variant="caption" color="error"><TranslationContent contentID="loginFailed"/></Typography>
              <br />
              <br />
            </>
          }
          <Button variant="contained" sx={{width: "225px"}} onClick={() => handleLogin()}><TranslationContent contentID="loginButton"/></Button>
          <br />
          <br />
          <br />
        </Paper>
      </LandingLayout>
    )
  }
}

export default Login;